// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nfDu","questions":"styles_questions__YMF6v","footer":"styles_footer__3zLCx"};